(() => {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.capGalleryReady === 'true') return;
    gallery.dataset.capGalleryReady = 'true';

    const rootProduct = gallery.closest('product-info');

    const pageThumbs = Array.from(gallery.querySelectorAll('[data-cap-thumb]'));
    const tabButtons = Array.from(gallery.querySelectorAll('[data-cap-tab-btn]'));

    const mainImageWrap = gallery.querySelector('[data-cap-page-image-wrap]');
    const mainImage = gallery.querySelector('[data-cap-main-image]');

    const pageVideoWrap = gallery.querySelector('[data-cap-page-video-wrap]');
    const pageVideo = gallery.querySelector('[data-cap-page-video]');

    const pageExternalWrap = gallery.querySelector('[data-cap-page-external-wrap]');
    const pageExternal = gallery.querySelector('[data-cap-page-external]');

    const modal = gallery.querySelector('[data-cap-modal]');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const modalItems = Array.from((modal || gallery).querySelectorAll('[data-cap-modal-item]'));
    const modalImageWrap = modal?.querySelector('[data-cap-modal-image-wrap]');
    const modalImage = modal?.querySelector('[data-cap-modal-image]');

    const modalVideoWrap = modal?.querySelector('[data-cap-modal-video-wrap]');
    const modalVideo = modal?.querySelector('[data-cap-modal-video]');

    const modalExternalWrap = modal?.querySelector('[data-cap-modal-external-wrap]');
    const modalExternal = modal?.querySelector('[data-cap-modal-external]');

    const groupTitle = modal?.querySelector('[data-cap-group-title]');
    const indexLabel = modal?.querySelector('[data-cap-index]');

    const openButtons = Array.from(gallery.querySelectorAll('[data-cap-open-modal]'));
    const closeButton = modal?.querySelector('[data-cap-close-modal]');
    const prevButton = modal?.querySelector('[data-cap-prev]');
    const nextButton = modal?.querySelector('[data-cap-next]');

    if (!pageThumbs.length) return;

    const items = pageThumbs.map((btn) => ({
      id: String(btn.dataset.mediaId),
      type: btn.dataset.mediaType,
      tab: btn.dataset.tab || (btn.dataset.mediaType === 'image' ? 'image' : 'video'),
      mainSrc: btn.dataset.mainSrc || '',
      fullSrc: btn.dataset.fullSrc || btn.dataset.mainSrc || '',
      videoSrc: btn.dataset.videoSrc || '',
      externalUrl: btn.dataset.externalUrl || '',
      poster: btn.dataset.poster || '',
      alt: btn.dataset.alt || '',
      width: btn.dataset.width || '',
      height: btn.dataset.height || ''
    }));

    let currentId = String(gallery.dataset.initialMediaId || items[0].id);
    let currentTab = gallery.dataset.initialTab || (items[0].tab || 'image');

    function getItem(id = currentId) {
      return items.find((item) => item.id === String(id)) || items[0];
    }

    function getItemsByTab(tab) {
      return items.filter((item) => item.tab === tab);
    }

    function updateNavVisibility(tab = currentTab) {
      const count = getItemsByTab(tab).length;
      const hide = count <= 1;

      if (prevButton) prevButton.hidden = hide;
      if (nextButton) nextButton.hidden = hide;
    }

    function pauseVideo(videoEl) {
      if (!videoEl) return;
      try {
        videoEl.pause();
      } catch (e) {}
    }

    function setVideo(videoEl, src, poster) {
      if (!videoEl) return;

      const currentSource = videoEl.querySelector('source');
      const currentSrc = currentSource ? currentSource.getAttribute('src') : '';

      if (poster) {
        videoEl.setAttribute('poster', poster);
      } else {
        videoEl.removeAttribute('poster');
      }

      if (currentSrc === src && currentSource) return;

      videoEl.innerHTML = '';

      if (src) {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        videoEl.appendChild(source);
      }

      try {
        videoEl.load();
      } catch (e) {}
    }

    function setImage(imgEl, src, alt, width, height) {
      if (!imgEl || !src) return;
      imgEl.src = src;
      imgEl.alt = alt || '';
      if (width) imgEl.setAttribute('width', width);
      if (height) imgEl.setAttribute('height', height);
    }

    function clearExternal(container) {
      if (!container) return;
      container.innerHTML = '';
    }

    function setExternal(container, url) {
      if (!container) return;

      container.innerHTML = url
        ? `<iframe
            src="${url}"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            loading="lazy"
          ></iframe>`
        : '';
    }

    function hideAllPageModes() {
      mainImageWrap?.classList.remove('is-active');
      pageVideoWrap?.classList.remove('is-active');
      pageExternalWrap?.classList.remove('is-active');
    }

    function hideAllModalModes() {
      modalImageWrap?.classList.remove('is-active');
      modalVideoWrap?.classList.remove('is-active');
      modalExternalWrap?.classList.remove('is-active');
    }

    function renderPage(item) {
      if (!item) return;

      pauseVideo(pageVideo);
      clearExternal(pageExternal);
      hideAllPageModes();

      if (item.type === 'image') {
        setImage(mainImage, item.mainSrc, item.alt, item.width, item.height);
        mainImageWrap?.classList.add('is-active');
        return;
      }

      if (item.type === 'video') {
        setVideo(pageVideo, item.videoSrc, item.poster);
        pageVideoWrap?.classList.add('is-active');
        return;
      }

      if (item.type === 'external_video') {
        setExternal(pageExternal, item.externalUrl);
        pageExternalWrap?.classList.add('is-active');
      }
    }

    function renderModal(item) {
      if (!item) return;

      pauseVideo(modalVideo);
      clearExternal(modalExternal);
      hideAllModalModes();

      if (item.type === 'image') {
        setImage(modalImage, item.fullSrc || item.mainSrc, item.alt, item.width, item.height);
        modalImageWrap?.classList.add('is-active');
        return;
      }

      if (item.type === 'video') {
        setVideo(modalVideo, item.videoSrc, item.poster);
        modalVideoWrap?.classList.add('is-active');
        return;
      }

      if (item.type === 'external_video') {
        setExternal(modalExternal, item.externalUrl);
        modalExternalWrap?.classList.add('is-active');
      }
    }

    function syncActive(id) {
      currentId = String(id);

      pageThumbs.forEach((btn) => {
        btn.classList.toggle('is-active', String(btn.dataset.mediaId) === currentId);
      });

      modalItems.forEach((btn) => {
        btn.classList.toggle('is-active', String(btn.dataset.mediaId) === currentId);
      });

      const pos = items.findIndex((item) => item.id === currentId);
      if (indexLabel && pos > -1) {
        indexLabel.textContent = `${pos + 1} / ${items.length}`;
      }
    }

    function updateTabUI(tab) {
  currentTab = tab;

  tabButtons.forEach((btn) => {
    btn.classList.toggle('is-active', btn.dataset.capTabBtn === tab);
  });

  modalItems.forEach((btn) => {
    const isSameTab = btn.dataset.tab === tab;
    btn.classList.toggle('is-hidden', !isSameTab);
  });

  if (groupTitle) {
    groupTitle.textContent =
      tab === 'video' ? 'Video per questo prodotto' : 'Immagini per questo prodotto';
  }

  updateNavVisibility(tab);
}

    function activate(id, scrollThumb = true, forcedTab = null) {
      const item = getItem(id);
      if (!item) return;

      currentTab = forcedTab || item.tab;

      renderPage(item);

      if (!modal.hidden) {
        renderModal(item);
      }

      syncActive(item.id);
      updateTabUI(currentTab);

      if (scrollThumb) {
        const pageActive = pageThumbs.find((btn) => String(btn.dataset.mediaId) === item.id);
        const modalActive = modalItems.find((btn) => String(btn.dataset.mediaId) === item.id);

        pageActive?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        modalActive?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    function openModal() {
      const item = getItem(currentId);
      updateTabUI(item.tab);
      renderModal(item);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cap-modal-open');
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cap-modal-open');
      pauseVideo(modalVideo);
      clearExternal(modalExternal);
    }

    function step(direction) {
      const list = getItemsByTab(currentTab);
      if (!list.length) return;

      const currentIndex = list.findIndex((item) => item.id === currentId);
      const safeIndex = currentIndex === -1 ? 0 : currentIndex;

      let nextIndex = safeIndex + direction;
      if (nextIndex < 0) nextIndex = list.length - 1;
      if (nextIndex >= list.length) nextIndex = 0;

      activate(list[nextIndex].id, true, currentTab);
    }

    function switchTab(tab) {
      const list = getItemsByTab(tab);
      if (!list.length) return;

      const currentItem = getItem(currentId);

      if (currentItem && currentItem.tab === tab) {
        updateTabUI(tab);
        if (!modal.hidden) renderModal(currentItem);
        return;
      }

      activate(list[0].id, true, tab);
    }

    pageThumbs.forEach((btn) => {
      btn.addEventListener('click', () => activate(btn.dataset.mediaId));
    });

    modalItems.forEach((btn) => {
      btn.addEventListener('click', () => activate(btn.dataset.mediaId, true, btn.dataset.tab));
    });

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => switchTab(btn.dataset.capTabBtn));
    });

    openButtons.forEach((btn) => {
      btn.addEventListener('click', openModal);
    });

    closeButton?.addEventListener('click', closeModal);
    prevButton?.addEventListener('click', () => step(-1));
    nextButton?.addEventListener('click', () => step(1));

    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;

      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });

    document.addEventListener(
      'variant:change',
      (event) => {
        if (rootProduct && event.target && !rootProduct.contains(event.target)) return;

        const variant = event.detail && event.detail.variant;
        if (!variant) return;

        const featuredId =
          variant.featured_media?.id ||
          variant.featured_image?.id ||
          null;

        if (!featuredId) return;

        const id = String(featuredId);
        if (items.some((item) => item.id === id)) {
          activate(id);
        }
      },
      true
    );

    activate(currentId, false, currentTab);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-cap-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();